import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useContext, useEffect } from "react";
import AppContext from "./AppContext";
import { ConfigProvider, theme } from "antd";
import { HashRouter, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import PasswordReset from "./components/PasswordReset";
import ChangePassword from "./components/ChangePassword";
import Layout from "./components/Layout";
import LoginLayout from "./components/LoginLayout";
import Cameras from "./components/camera/Cameras";
import CameraForm from "./components/camera/CameraForm";
import { gapi } from "gapi-script";
import msalInstance, { Client_id } from "./Constants";
import Users from "./components/users/Users";
import UserForm from "./components/users/UserForm";
import Alarms from "./components/alarms/Alarms";
import AlarmForm from "./components/alarms/AlarmForm";
import Settings from "./components/Settings";
import Models from "./components/model/Models";
import ModelForm from "./components/model/ModelForm";
import ModelTemplates from "./components/model_template/ModelTemplates";
import ModelTemplateForm from "./components/model_template/ModelTemplateForm";
import TurnServers from "./components/turn_server/TurnServers";
import TurnServersForm from "./components/turn_server/TurnServerForm";
function App() {
  useEffect(() => {
    async function start() {
      try {
        await gapi.client.init({
          clientId: Client_id,
          scope: "",
        });
      } catch (error) {
        console.error("Error initializing Google client:", error);
      }
    }

    gapi.load("client:auth2", start);
    msalInstance.initialize();
  }, []);
  const authCtx = useContext(AppContext);
  // const isLoggedIn = true;
  const isLoggedIn = authCtx.isLoggedIn;

  const { defaultAlgorithm, darkAlgorithm } = theme;
  return (
    <>
      {isLoggedIn ? (
        <HashRouter>
          <ConfigProvider
            theme={{
              algorithm: darkAlgorithm,
            }}
          >
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                {/* <Route path="/" element={<Dashboard />} /> */}
                <Route path="/cameras" element={<Cameras />} />
                <Route path="/cameras/:id" element={<CameraForm />} />
                <Route path="/models" element={<Models />} />
                <Route path="/models/:id" element={<ModelForm />} />
                <Route path="/turnServers" element={<TurnServers />} />
                <Route path="/turnServers/:id" element={<TurnServersForm />} />
                <Route path="/modelTemplates" element={<ModelTemplates />} />
                <Route
                  path="/modelTemplate/:id"
                  element={<ModelTemplateForm />}
                />
                <Route path="/users" element={<Users />} />
                <Route path="/users/:id" element={<UserForm />} />
                <Route path="/alarms" element={<Alarms />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/alarms/:id" element={<AlarmForm />} />
              </Routes>
              <ToastContainer />
            </Layout>
          </ConfigProvider>
        </HashRouter>
      ) : (
        <HashRouter>
          <LoginLayout>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/resetPassword" element={<PasswordReset />} />
              <Route path="/changePassword/:id" element={<ChangePassword />} />
            </Routes>
          </LoginLayout>
        </HashRouter>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </>
  );
}

export default App;
